export const dConcernHeader = pov => {
  switch (window.d_concern_abcd) {
    case 2:
    case 4:
      return "What is the diagnosis?"
    default:
      return `Is there a specific diagnosis ${
        pov === "self" ? "you" : "they"
      } are wondering about?`
  }
}



// WEBPACK FOOTER //
// ./assets/feedback/optimize.js